<template>
  <v-dialog
    persistent
    transition="dialog-bottom-transition"
    min-height="500"
    width="500"
  >
    <template v-slot:activator="{ props }">
      <v-btn color="primary" variant="text" size="x-small" v-bind="props"
        >Forgot Password</v-btn
      >
    </template>
    <template v-slot:default="{ isActive }">
      <v-card>
        <v-toolbar
          class="rounded-lg"
          color="primary"
          title="Reset Password"
        ></v-toolbar>
        <v-card-text>
          <v-text-field
            v-model="resetEmail"
            label="Email"
            type="email"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            :disabled="invalidEmail"
            variant="text"
            @click="() => resetPassword(isActive)"
            >Send Reset Email</v-btn
          >
          <v-btn variant="text" color="error" @click="isActive.value = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from "vue";
import { useFirebaseAuth } from "vuefire";
import { useAlertStore } from "@/store/alert";
import { sendPasswordResetEmail } from "firebase/auth";
const auth = useFirebaseAuth();
const alertStore = useAlertStore();
const resetEmail = ref("");
const invalidEmail = computed(() => !/.+@.+\..+/.test(resetEmail.value));
const resetPassword = (closeDialog) => {
  sendPasswordResetEmail(auth, resetEmail.value)
    .then(() => {
      alertStore.showAlert(
        "An email has been sent to reset your password.",
        "success",
      );
      closeDialog.value = false;
    })
    .catch((error) => {
      alertStore.showAlert(
        "There was an error sending the reset email. Please try again or contact support.",
        "error",
      );
    });
};
</script>
